import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step591073Meta extends BaseModel {
  /**
   * @var {?boolean}
   */
  hasNotifiedCourt;

  /**
   * @var {?boolean}
   */
  hasConfirmedFinalValues;

  constructor(model = {}) {
    super();

    this.hasNotifiedCourt = model.hasNotifiedCourt;
    this.hasConfirmedFinalValues = model.hasConfirmedFinalValues;
  }
}
